module.exports = __webpack_public_path__ + "img/background.6f3c4d45.jpg";